import { translator } from "@shop/frontend/web/js/services/TranslatorService";

export default class RegisterForm {
    constructor(form) {
        this.form = form;
        this.isAgreementsTouched = false;
    }

    init() {
        const form = $(this.form);
        form.on(
            'change',
            `[name="RegistrationForm[agree]"],
            [name="RegistrationForm[user_agreement]"],
            [name="FastRegistrationForm[agree]"],
            [name="FastRegistrationForm[user_agreement]"]`,
            () => {
                this.isAgreementsTouched = true;
            }
        );

        $(form).on("afterValidate", (event, messages, errorAttributes) => {
            const button = $(form).find('.js-form-submit-button');
            const hasAnyError = Object.values(messages).some(message => message.length > 0);
            const checkboxError = $('.help-block_agreements');
            const hasAgreementError = Object.entries(messages).some(([key, value]) => {
                return key.includes('agree') && value.length > 0;
            });

            if(this.isAgreementsTouched && hasAgreementError) {
                checkboxError.addClass('has-error');
                checkboxError.text(translator.t('main', 'To successfully register, you must check the boxes "I have read the User Agreement" and "I consent to the processing of personal data"'));
            } else {
                checkboxError.removeClass('has-error')
                checkboxError.text('');
            }

            if (hasAnyError) {
                button.addClass('disabled');
                button.prop('disabled');
            } else {
                button.removeClass('disabled');
                button.removeAttr('disabled');
            }
        });
    }
}